import { render, staticRenderFns } from "./News.vue?vue&type=template&id=8a09550c&scoped=true&"
import script from "./News.vue?vue&type=script&lang=js&"
export * from "./News.vue?vue&type=script&lang=js&"
import style0 from "./News.vue?vue&type=style&index=0&id=8a09550c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a09550c",
  null
  
)

export default component.exports